export default function clearLocalStorage() {
  const i18nextLng = localStorage.getItem('i18nextLng');
  localStorage.clear();
  localStorage.setItem('i18nextLng', i18nextLng);
}
